import InfoPopup from "@/components/InfoPopup/InfoPopup";
import { Toggle } from "@/components/Toggle";
import { useTrans } from "@/translations";

import { useContext } from "react";

import { twMerge } from "tailwind-merge";

import { ReportingTableContext } from "../../context";

export const ReportingZonesToggle: React.FC = () => {
  const { t } = useTrans();
  const { showZones, setShowZones } = useContext(ReportingTableContext);

  return (
    <div className="inline-flex items-center gap-[8px]">
      <Toggle
        checked={showZones}
        onChange={setShowZones}
        label={t("reportingPage:zonesToggleLabel")}
        labelClassName={twMerge(
          "mr-0 ml-[9px] text-[12.5px] font-medium text-[#1D1C1C]",
          showZones && "font-semibold",
        )}
        width={32}
        height={18}
        handleDiameter={12}
        offColor="#fff"
        onColor="#E7EB5D"
        offHandleColor="#C9C1C1"
        onHandleColor="#1D1C1C"
        trackBorderColor="#DAD3D3"
        trackBorderColorChecked="#1D1C1C"
      />
      <InfoPopup
        id="showZones"
        text={t("reportingPage:zonesTogglePopupText")}
        width="350px"
        size={16}
        className="flex cursor-help"
      />
    </div>
  );
};
